import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/loginView',
    name: 'LoginView',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/',
    name: 'InDex',
    component: () => import('@/views/Index.vue')
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import('@/views/rule.vue')
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import('@/views/refund.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/privacy.vue')
  },
  {
    path: '/clause',
    name: 'clause',
    component: () => import('@/views/clause.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/pay.vue')
  },
  {
    path: '/succeed',
    name: 'succeed',
    component: () => import('@/views/succeed.vue')
  },
  {
    path: '/lose',
    name: 'lose',
    component: () => import('@/views/lose.vue')
  },
  {
    path: '/loading',
    name: 'loading',
    component: () => import('@/views/LoadingPage.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
  {
    path: '/transfer',
    name: 'Transfer',
    component: () => import('@/views/Transfer.vue')
  },
  {
    path: '/pending',
    name: 'Pending',
    component: () => import('@/views/Pending.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/index.html#'), 
  routes
})

export default router